import { useNavigate } from 'react-router-dom'
import styles from '../../styles/admin/CenterInfoBox.module.scss'
import SaveButton from '../common/SaveButton'

interface CenterInfoBoxProps {
  centerData: {
    ID: number
    NAME: string
    MANAGER_NAME: string
    MANAGER_EMAIL: string
    ADDRESS: string
    PHONE: string
    REG_DTM: string
  }
}

const CenterInfoBox = ({ centerData }: CenterInfoBoxProps) => {
  const navigate = useNavigate()

  let totalStudents = '23,423'
  let totalClasses = 200
  let satisfactionRate = 40
  let avgClassTime = 30

  const handleChangeManageAccount = () => {
    navigate('/dashboard/manager', {
      state: { centerId: centerData.ID },
    })
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>{centerData.NAME} 관리</h2>
        <SaveButton
          className={styles.dashboardButton}
          onClick={handleChangeManageAccount}
        >
          수업 Dashboard 보기
        </SaveButton>
      </div>

      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <div className={styles.statIcon}><img src="/assets/icons/user.png" alt="user" style={{ width: 24, height: 24, objectFit: 'contain' }} /></div>
          <div className={styles.statContent}>
            <div className={styles.statLabel}>학생 수</div>
            <div className={styles.statValue}>
              {totalStudents.toLocaleString()}
            </div>
            <div className={styles.statChange}>↗ 65%</div>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statIcon}>📈</div>
          <div className={styles.statContent}>
            <div className={styles.statLabel}>총 등록 수업 수</div>
            <div className={styles.statValue}>{totalClasses}</div>
            <div className={styles.statChange}>↗ 25%</div>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statIcon}><img src="/assets/icons/star.png" alt="progress" style={{ width: 24, height: 24, objectFit: 'contain' }} /></div>
          <div className={styles.statContent}>
            <div className={styles.statLabel}>전체 학생 학습 진도율</div>
            <div className={styles.statValue}>{satisfactionRate}%</div>
            <div className={styles.statChange}>↘ 5%</div>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statIcon}>⏰</div>
          <div className={styles.statContent}>
            <div className={styles.statLabel}>평균 학습 시간</div>
            <div className={styles.statValue}>{avgClassTime}min</div>
            <div className={styles.statChange}>↘ 5%</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CenterInfoBox
